import { useStatQuery } from '@famly/stat_use-stat-query';
import { StatPermissionsForm } from './stat-permissions-form.query';
export function useStatPermissionsFormQuery(options) {
    const queryResult = useStatQuery(StatPermissionsForm, options);
    // add cache updates here
    return queryResult;
}
